import { Card } from 'react-bootstrap';
import { BsGeoAlt, BsClock, BsEnvelope, BsTelephone } from 'react-icons/bs';
import { getAboutImage } from '@/utils/imageUrl';

const ContactOfficeCard = ({ sectionData = null }) => {
  const content = sectionData?.content || {};
  const addressTitle = content.address_title || 'Head Office';
  const addressLines = Array.isArray(content.address_lines)
    ? content.address_lines
    : ['South Crete Tours S.A.', '16 Kapetan Sifi Avenue', 'Ierapetra, 72200 Crete, Greece'];
  const addressHoursLabel = content.hours_label || 'Opening hours';
  const addressHoursValue = content.hours_value || 'Mon - Sat, 09:00 - 20:00';
  const addressSupportLabel = content.support_label || 'Support';
  const addressSupportEmail = content.support_email || 'support@southcrete.gr';
  const addressPhoneLabel = content.phone_label || 'Telephone';
  const addressPhone = content.phone || '+30 28420 22892';
  const officeImage = getAboutImage(content.office_image || 'pictures/about/story-our-team.jpg');

  return (
    <Card className="contact-office-card h-100 border-0 shadow-sm">
      <div className="contact-office-card__image-wrap">
        {officeImage ? <img src={officeImage} alt="South Crete Tours office" className="contact-office-card__image" /> : null}
      </div>
      <Card.Body className="contact-office-card__body">
        <div className="contact-office-card__title-row">
          <span className="contact-office-card__icon">
            <BsGeoAlt />
          </span>
          <h4 className="contact-office-card__title mb-0">{addressTitle}</h4>
        </div>

        <p className="contact-office-card__address mb-0">
          {addressLines.map((line, idx) => (
            <span key={`${line}-${idx}`}>
              {line}
              <br />
            </span>
          ))}
        </p>

        <div className="contact-office-card__meta-list">
          <div className="contact-office-card__meta-row">
            <span className="contact-office-card__icon">
              <BsClock />
            </span>
            <div>
              <strong>{addressHoursLabel}</strong>
              <div>{addressHoursValue}</div>
            </div>
          </div>

          <div className="contact-office-card__meta-row">
            <span className="contact-office-card__icon">
              <BsEnvelope />
            </span>
            <div>
              <strong>{addressSupportLabel}</strong>
              <div>
                <a className="text-decoration-underline" href={`mailto:${addressSupportEmail}`}>
                  {addressSupportEmail}
                </a>
              </div>
            </div>
          </div>

          <div className="contact-office-card__meta-row">
            <span className="contact-office-card__icon">
              <BsTelephone />
            </span>
            <div>
              <strong>{addressPhoneLabel}</strong>
              <div>
                <a className="text-decoration-underline" href={`tel:${addressPhone.replace(/\s+/g, '')}`}>
                  {addressPhone}
                </a>
              </div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ContactOfficeCard;
